import React from "react";
import Header from "./Header";
import Footer from "./Footer";

const AppLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-white">


      <main className="flex-1">{children}</main>


    </div>
  );
};

export default AppLayout;
